var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHipHopMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Radio-Stereo-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Radio Stereo 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11h-1.45a0.25 0.25 0 0 1 -0.23 -0.16l-1.14 -3a2 2 0 0 0 -1.87 -1.3H9.19A2 2 0 0 0 7.32 7.8l-1.14 3A0.25 0.25 0 0 1 6 11H4.5A4.51 4.51 0 0 0 0 15.5v2A6.51 6.51 0 0 0 6.5 24h11a6.51 6.51 0 0 0 6.5 -6.5v-2a4.51 4.51 0 0 0 -4.5 -4.5Zm-1 9a3 3 0 1 1 3 -3 3 3 0 0 1 -3 3Zm-4.5 0.25a0.75 0.75 0 0 1 0 1.5h-4a0.75 0.75 0 0 1 0 -1.5Zm-4 -5.75a1 1 0 0 1 1 -1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 -1 -1ZM8.5 17a3 3 0 1 1 -3 -3 3 3 0 0 1 3 3Zm0.63 -8.34a0.25 0.25 0 0 1 0.24 -0.16h5.26a0.25 0.25 0 0 1 0.24 0.16l0.75 2a0.23 0.23 0 0 1 0 0.23 0.25 0.25 0 0 1 -0.21 0.11H8.62a0.25 0.25 0 0 1 -0.21 -0.11 0.23 0.23 0 0 1 0 -0.23Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6a1 1 0 0 0 2 0 1 1 0 0 1 1 -1 1 1 0 0 0 0 -2 3 3 0 0 0 -3 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6a1 1 0 0 0 1 -1 3 3 0 0 1 3 -3 1 1 0 0 0 0 -2 5 5 0 0 0 -5 5 1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0 -3 -3 1 1 0 0 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 2a3 3 0 0 1 3 3 1 1 0 0 0 2 0 5 5 0 0 0 -5 -5 1 1 0 0 0 0 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHipHopMusic);
export default ForwardRef;